import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { Control, Controller, FieldValues } from 'react-hook-form';

import { translate } from '@/ui/i18n';

interface IProps {
  value?: boolean | null;
  control: Control<FieldValues, any>; // eslint-disable-line
  name: string;
  onBlur?: () => void;
  onChange?: () => void;
}

export function FSRadioGroup({
  value,
  control,
  name,
  onBlur,
  onChange,
}: IProps) {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={value}
      render={({ field }) => (
        <RadioGroup
          {...field}
          onBlur={() => {
            field.onBlur();
            onBlur?.();
          }}
          onChange={(event, value) => {
            field.onChange(event, value);
            onChange?.();
          }}
        >
          <FormControlLabel
            value={'true'}
            control={
              <Radio
                onClick={(event) => {
                  // HACK to focus the input (because onBlur did not work on safari)
                  const target = event.target as HTMLInputElement;
                  target.focus();
                }}
              />
            }
            label={translate('Form.yes')}
          />
          <FormControlLabel
            value={'false'}
            control={
              <Radio
                onClick={(event) => {
                  // HACK to focus the input (because onBlur did not work on safari)
                  const target = event.target as HTMLInputElement;
                  target.focus();
                }}
              />
            }
            label={translate('Form.no')}
          />
        </RadioGroup>
      )}
    />
  );
}
